var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"choice-button-warp"},[_c('vh-button',_vm._g(_vm._b({staticClass:"choice-button",attrs:{"disabled":!_vm.hasPermission}},'vh-button',_vm.$attrs,false),_vm.$listeners),[_vm._v(" "+_vm._s(_vm.label)+" ")]),(!_vm.hasPermission)?_c('span',{staticClass:"not-auth"},[_vm._v("未开通权限")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }